import { getFetch } from '@/plugins/http'
import { postFetch } from '@/plugins/http'

const baseHost = `${process.env.VUE_APP_HOST}`

export default {
  /**
   * 通过token获取用户信息
   */
  getUserInfo(params = {}) {
    return getFetch(`${baseHost}/hike-boot/sys/user/info`, params)
  },
  /**
   * 登录
   */
  getLogin(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/sys/login`, params, config)
  },

  /**
   * 退出登录
   * @param {*} params
   * @returns
   */
  logout() {
    return postFetch(`${baseHost}/hike-boot/sys/logout`, {})
  },

  /**
   * 导航
   */
  getNavList(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-nav_list/portal_homepage`, params)
  },
  /**
   * 相关数据
   */
  getTeachData(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-data_display_list/portal_homepage`, params)
  },
  /**
   * 首页数据列表
   */
  getDataList(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-all_list/portal_homepage`, params)
  },
  /**
   * 首页_Banner
   */
  getBannerList(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-banner_list/portal_homepage`, params)
  },

  /**
   * 首页_友情链接
   */
  getFooterLink(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-links_list/portal_homepage`, params)
  },
  /**
   * 首页_精品MOOC
   */
  getHomeMooc(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-recommend_mooc_list/portal_homepage`, params)
  },
  /**
   * 首页_精品SPOC
   */
  getHomeSpoc(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-recommend_spoc_list/portal_homepage`, params)
  },

  /**
   * 基础配置信息
   */
  getBaseSet(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/32-base_info/common_config`, params)
  },

  // 项目已开启功能
  getObjectOpen(params, config) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-enabled_function/common_config`, params, config)
  },

  // 获取首页菜单卡片
  getHomeMenuCard(params) {
    return getFetch(`${baseHost}/hike-boot/common/api/32-getApplicationInfoMap/portal_homepage`, params)
  },
}
